module.exports = __webpack_public_path__ + "static/media/mac88-virtual.f4faaf5a.webp";